var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgServiceBoard = function SvgServiceBoard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33337 10.8333C6.33337 8.53211 8.19885 6.66663 10.5 6.66663H30.5C32.8012 6.66663 34.6667 8.53211 34.6667 10.8333V34.1666C34.6667 36.4678 32.8012 38.3333 30.5 38.3333H10.5C8.19886 38.3333 6.33337 36.4678 6.33337 34.1666V10.8333ZM10.5 9.99996C10.0398 9.99996 9.66671 10.3731 9.66671 10.8333V34.1666C9.66671 34.6269 10.0398 35 10.5 35H30.5C30.9603 35 31.3334 34.6269 31.3334 34.1666V10.8333C31.3334 10.3731 30.9603 9.99996 30.5 9.99996H10.5Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6667 3.33325C18.286 3.33325 17.1667 4.45254 17.1667 5.83325H15.5C14.1193 5.83325 13 6.95254 13 8.33325V9.16658C13 10.5473 14.1193 11.6666 15.5 11.6666H25.5C26.8807 11.6666 28 10.5473 28 9.16658V8.33325C28 6.95254 26.8807 5.83325 25.5 5.83325H23.8333C23.8333 4.45254 22.714 3.33325 21.3333 3.33325H19.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6667 4.99996C19.2065 4.99996 18.8334 5.37306 18.8334 5.83329C18.8334 6.75377 18.0872 7.49996 17.1667 7.49996H15.5C15.0398 7.49996 14.6667 7.87306 14.6667 8.33329V9.16663C14.6667 9.62686 15.0398 9.99996 15.5 9.99996H25.5C25.9603 9.99996 26.3334 9.62686 26.3334 9.16663V8.33329C26.3334 7.87306 25.9603 7.49996 25.5 7.49996H23.8334C22.9129 7.49996 22.1667 6.75377 22.1667 5.83329C22.1667 5.37306 21.7936 4.99996 21.3334 4.99996H19.6667ZM15.8467 4.16663C16.4897 2.69504 17.9581 1.66663 19.6667 1.66663H21.3334C23.042 1.66663 24.5104 2.69504 25.1533 4.16663H25.5C27.8012 4.16663 29.6667 6.03211 29.6667 8.33329V9.16663C29.6667 11.4678 27.8012 13.3333 25.5 13.3333H15.5C13.1989 13.3333 11.3334 11.4678 11.3334 9.16663V8.33329C11.3334 6.03211 13.1989 4.16663 15.5 4.16663H15.8467Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18.3333C18 17.4128 18.7462 16.6666 19.6667 16.6666H26.3333C27.2538 16.6666 28 17.4128 28 18.3333C28 19.2538 27.2538 20 26.3333 20H19.6667C18.7462 20 18 19.2538 18 18.3333Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24.1667C18 23.2462 18.7462 22.5 19.6667 22.5H26.3333C27.2538 22.5 28 23.2462 28 24.1667C28 25.0871 27.2538 25.8333 26.3333 25.8333H19.6667C18.7462 25.8333 18 25.0871 18 24.1667Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 29.9999C18 29.0794 18.7462 28.3333 19.6667 28.3333H26.3333C27.2538 28.3333 28 29.0794 28 29.9999C28 30.9204 27.2538 31.6666 26.3333 31.6666H19.6667C18.7462 31.6666 18 30.9204 18 29.9999Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServiceBoard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/service-board.4b1be8f5.svg";
export { ForwardRef as ReactComponent };